// 创建文件en/index.js
const German = {
    rejected: "Abgelehnt",
    my: "Mein",
    today: "Heute",
    this_week: "Diese Woche",
    this_month: "Diesen Monat",
    last_month: "Letzten Monat",
    this_year: "Dieses Jahr",
    number_of_people: "Anzahl der Personen",
    amount: "Betrag",
    enter_username_id_to_search: "Benutzernamen-ID eingeben, um zu suchen",
    team_list: "Teamliste",
    registration_time: "Registrierungszeit",
    selling_face_value: "Verkaufs nominalwert",
    click_for_details: "Klicken Sie für Details",
    "agent_login": "Agenten-Anmeldung",
    'SignOut': 'Abmelden',
    'Contact us': "Kontaktieren Sie uns",
    'Download our app': "Laden Sie unsere App herunter",
    'Download it from': "Download-URL",
    'About Us': "Gobuy USA wurde 2012 gegründet",
    'Gobuy USA was founded in 2012': "FAQ",
    'Customer service': "über uns",
    'frequently asked question': "Vertrieb und Lieferung",
    'Return and exchange policy': "Kundendienst",
    'Shipping and distribution': "Kontaktieren Sie uns per E-Mail",
    'Contact us by email': "Rückgabe- und Umtauschbedingungen",
    'Privacy Policy and Terms of Use': "Datenschutzrichtlinie und Nutzungsbedingungen",
    'Privacy Policy': "Datenschutzrichtlinie",
    'Terms of use': "Nutzungsbedingungen",
    'Upload credentials': "Anmeldeinformationen hochladen",
    'The withdrawal is being processed': "Auszahlung läuft",
    'Cause of failure': "Grund für das Scheitern",
    'Your shopping cart is still empty': "Ihr Warenkorb ist noch leer",
    'Log in to view the items in your cart': "Melden Sie sich an, um die Artikel im Warenkorb anzuzeigen",
    'Browse around': "Durchsuchen",
    'Account correlation': "Zahlungsadresse",
    'Order management': "Einstufung",
    'Payment method': "Kontobezogen",
    'Collection address': "Auftragsverwaltung",
    Category: "Zahlungsart",
    "MyCommission": "meine Provision",
    "Gross income": "Gesamtumsatz",
    "Direct commission": "direkte Provision",
    "Indirect commission": "indirekte Provision",
    "Transfer to wallet": "Auf Wallet übertragen",
    "Tip: The transfer amount must be greater than 10USDT": "Tipp: Der Überweisungsbetrag muss größer als 10USDT sein",
    "transfer": "überweisen",
    "commission": "Kommission",
    "Please enter": "Bitte treten Sie ein",
    'Old Password': "Altes Passwort",
    'Change password': "Kennwort ändern",
    'Amazon GIFT CARD': "Amazon-Geschenkkarte",
    'High Priced Recycling': "Hochpreisiges Recycling",
    'Data': "Datum",
    'congratulations': "Glückwunsch",
    'Obtain': "erhalten",
    'ThankYouForParticipating': "Vielen Dank für Ihre Teilnahme",

    // navbar"",
    Home: "Titelseite",
    Search: "suchen",
    ShoppingCart: "Warenkorb",
    Mine: "meins",

    // 首页
    // 搜索
    EnterSearchContent: "Geben Sie Suchinhalte ein",
    'Recent searches': "Aktuelle Suchanfragen",
    'popular searches': "Beliebte Suchanfragen",
    'Please search': "Bitte geben Sie die Schlüsselwörter ein, nach denen Sie suchen möchten",
    'orderSearch': "Geben Sie den Bestell- oder Produktnamen ein, um zu suchen",

    // 语言
    'Language selection': "Sprachauswahl",

    // menu
    Brand: "Marke",
    Collect: "sammeln",
    Manage: "verwalten",
    Order: "Befehl",
    Wallet: "Geldbörse",
    BlindBox: "Blindbox",
    MenuGiftCard: "Geschenkkarte",
    // HotSale
    HotSale: "Die neuesten Nachrichten sind im Angebot...",
    // tabs"",
    TodaysOffer: "Plattformempfehlung",
    'Phone': "Handy",
    'Smart Watch': "Smartwatch",
    'Smart bracelet': "intelligentes Armband",

    // gobuy
    'home.gobuy.title': "Überraschungen warten auf Sie",
    'home.gobuy.periods': "Blindbox rund",
    'home.gobuy.freeze': "Nehmen Sie am Countdown teil",
    'home.gobuy.drawing': "Countdown starten",
    'home.gobuy.buy': "teilnehmen",
    'home.gobuy.isbuy': "Habe bereits teilgenommen",
    USDT: "USDT",
    'home.gobuy.jackpot': "Preispool",
    Purse: "Geldbörse",
    Box: "Blindbox",
    'GetAPrize': "Holen Sie sich Preise",
    Discount: "Rabatt",
    when: "Wann",
    points: "Integral",
    seconds: "Zweite",
    // MessageBox
    'MessageBox.Tips': "Hinweis",
    'MessageBox.Confirm': "bestätigen",
    'MessageBox.Cancel': "Stornieren",
    'MessageBox.buy.box': "Sind Sie sicher, dass Sie diese Blindbox kaufen möchten?",
    // Toast
    'succ': "Erfolg",
    'err': "Fehler",
    'box.succeeds': "Kauf erfolgreich",
    'box.frozen': "Habe bereits teilgenommen",
    'box.issue': "Pro Ausgabe kann nur eine Blindbox erworben werden",

    // 商品列表
    filter: "Filter",
    sales: "Verkaufsvolumen",
    selfOP: "Selbstbetrieben",
    noMore: "nicht mehr",
    brand: "Marke",
    confirm: "bestätigen",
    reset: "zurücksetzen",
    ComSor: "Umfassende Sortierung",
    MostPop: "am beliebtesten",
    HighLow: "Preis von hoch nach niedrig",
    LowHigh: "Preis von niedrig bis hoch",
    SalVol: "Verkaufsvolumen",
    NewArr: "Neu eingetroffen",

    // 购物车
    'cart.cart': "Warenkorb",
    'cart.edit': "bearbeiten",
    'cart.done': "Beenden",
    'home.cart.voucher': "Holen Sie sich Gutscheine",
    'home.cart.outstock': "ausverkauft",
    'home.cart.offshelf': "Aus den Regalen entfernt",
    'Only': "nur",
    'left': "individuell",
    'Promotion': "Förderung",
    'cart.all': "Alles auswählen",
    'cart.total': "gesamt",
    'cart.delete': "löschen",
    'cart.checkout': "Die Rechnung, bitte",

    // 我的
    'Direct': "direkt",
    'Indirect': "indirekt",
    'MyOrders': "meine Bestellung",
    'ViewAll': "Alle anzeigen",
    'Unpaid': "Ausstehende Zahlung",
    'ToShip': "Warten auf Versand",
    'ToReceive': "Warte auf Erhalt",
    'ToReview': "Warten auf Bewertung",
    // 盲盒
    'MyBlindBox': "Blindbox-Liste",
    'WaitingDraw': "Warten auf die Auslosung",
    'Opened': "Geöffnet (Empfang/Rückgabe)",
    // 礼品卡
    'After sale': "After-Sales",
    'GiftCard': "Schallplatten recyceln",
    'RecycleGiftCard': "Geschenkkarten recyceln",
    'Verifying': "überprüfen",
    'Rebuying': "Nachkauf",
    'Repurchased': "Warten auf Zahlung",
    'Paid': "Die Zahlung ist erfolgt",
    // 常用工具
    'CommonTools': "Gängige Werkzeuge",
    'MyWallet': "meine Brieftasche",
    'VirtualOrders': "virtuelle Ordnung",
    'Refunds': "Erstattung",
    'MyFriends': "meine Freunde",
    'ChatList': "Chat-Liste",
    'RealNameVerification': "Authentifizierung mit echtem Namen",
    'MyFavorites': "meine Sammlung",
    'Addresses': "Adressverwaltung",
    'MyReviews': "Meine Rezension",
    'BrowsingHistory': "Durchsuchen Sie den Verlauf",
    'Promotions': "Werbeaktionen",
    'StoreManagement': "Filialleitung",
    'BecomeASeller': "Werden Sie Verkäufer",

    // 订单列表
    'SearchPlaceholder': "Geben Sie den Produktnamen der Bestellung ein, um zu suchen",
    All: "alle",
    OrderNo: "Bestellnummer",
    items: "Stücke",
    ShippingFee: "Fracht",
    'Refund in Progress': "Rückerstattung läuft",
    'Cancel Order': "Bestellung stornieren",
    'Refund': "Erstattung",
    'Track Shipping': "Überprüfen Sie die Logistik",
    'Confirm Receipt': "den Wareneingang bestätigen",
    'Evaluate': "auswerten",
    'Delete': "löschen",
    'Pay': "Zahlung",
    'MessageBox.delete.order': "Sind Sie sicher, dass Sie diese Bestellung löschen möchten?",
    'MessageBox.cancel.order': "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?",
    'MessageBox.receive.order': "Ist diese Bestellung eingegangen?",
    // 订单详情
    'Order Details': "Bestelldetails",
    'Pickup Code': "Abholcode",
    'Complaint': "Beschwerde",
    'After-Sales': "After-Sales",
    'Gift': "Geschenk",
    'Order Date': "Bestelldatum",
    'Used voucher worth': "Betrag des verwendeten Gutscheins",
    'CNY': "RMB",
    'Payment Method': "Zahlungsart",
    'Total Product Amount': "Gesamtproduktmenge",
    'Shipping Fee': "Fracht",
    'Amount Paid': "Gezahlter Betrag",
    'Return': "die Ware zurückschicken",
    // 盲盒列表
    'Pending Draw': "Warten auf die Verlosung der Lotterie",
    'Pending Unboxing': "Zu öffnen",
    'Unboxed': "Bereits eingeschaltet",
    'Collected': "Erhalten",
    'Recycled': "Recycelt",
    'Unknown': "unbekannt",
    'Claim': "erhalten",
    'Recycle': "Rückkauf",
    'Unbox': "einschalten",
    'MessageBox.recycle.box': "Sind Sie sicher, dass Sie diese Blindbox recyceln möchten?",
    // 盲盒详情
    'Mystery Box Details': "Details zur Blindbox",
    'Unopened': "Nicht eingeschaltet",
    'box.opened': "Nicht eingeschaltet",
    'Claimed': "Erhalten",
    'Confirm Claim': "Abholung bestätigen",
    'MessageBox.pick.box': "Sind Sie sicher, dass Sie diese Blindbox extrahieren möchten?",
    // 盲盒提货
    'Please add address': "Bitte Adresse hinzufügen",
    // 礼品卡列表
    'Face Value Total': "Gesamtnennwert",
    // 礼品卡详情
    'Gift Card Details': "Details zur Geschenkkarte",
    'Card number': "Kartennummer",
    'Activation code': "Aktivierungscode",
    'Actual recovery price': "tatsächlicher Recyclingpreis",
    // 礼品卡回收
    'Gift Card Recycling': "Recycling von Geschenkkarten",
    'Confirm Recycling': "Bestätigen Sie das Recycling",
    'Please enter the card number': "Bitte Kartennummer eingeben",
    'Please enter the activation code': "Bitte geben Sie den Aktivierungscode ein",
    'MessageBox.recycle.gift': "Sind Sie sicher, dass Sie diese Geschenkkarte recyceln möchten?",

    // 我的钱包
    'My Wallet': "meine Brieftasche",
    'Available Balance': "verfügbares Guthaben",
    'Frozen Funds': "Gelder einfrieren",
    'Recharge': "nachfüllen",
    "can": "Kann",
    'Withdraw': "Bargeld abheben",
    'Withdrawal Accounts': "Konto abheben",
    // 充值
    'Recharge Details': "Details zum Aufladen",
    'Recharge Order No.': "Bestellnummer aufladen",
    'Recharge Amount': "Aufladebetrag",
    'Creation Time': "Schöpfungszeit",
    'MessageBox.recharge.pop': "Bitte geben Sie den Aufladebetrag ein",
    // 付款
    'payment': "Zahlung",
    'Order submitted successfully, please select payment method': "Bestellung erfolgreich übermittelt, bitte wählen Sie die Zahlungsart aus",
    'Rechargeable card': "wiederaufladbare Karte",
    'Please enter a hash': "Bitte Hash eingeben",
    'Immediate payment': "Bezahlen Sie jetzt",
    'Wait for the file to load': "Bitte warten Sie, bis die Datei geladen ist",
    // 提现
    'Withdrawal Details': "Details zur Auszahlung",
    'Withdrawal Amount': "Betrag abheben",
    'Application Time': "Bewerbungszeitpunkt",
    'New Application': "neue Anwendung",
    'Payment Password': "Zahlungspasswort",
    'New Payment Password': "Neues Zahlungspasswort",
    'Recipient Information': "Informationen zum Zahlungsempfänger",
    'Submit': "einreichen",
    'Add Recipient Account First': "Bitte fügen Sie zunächst ein Zahlungskonto hinzu",
    'Please bind your mobile phone or email first': "Bitte binden Sie zuerst Ihr Mobiltelefon oder Ihre E-Mail-Adresse ein",
    // 设置
    'Account Settings': "Kontoeinstellungen",
    'Change Login Password': "Login-Passwort ändern",
    'Change Payment Password': "Zahlungspasswort ändern",
    'Log Out': "Abmelden",
    'Mobile': "Handy",
    'Verification Code': "Bestätigungscode",
    'Email': "Post",
    'New Password': "Neues Passwort",
    'Confirm Password': "Passwort bestätigen",
    'Modify': "Überarbeiten",
    'Bind': "Bindung",
    ' Mobile': "Handy",
    ' Email': "Post",
    // 资金详情
    'Fund Details': "Einzelheiten zur Finanzierung",
    'Withdrawal Account': "Konto abheben",
    'Account Type': "Kontotyp",
    'USDT Address (TRC20)': "USDT-Adresse (TRC20)",
    'Edit': "bearbeiten",
    'Delete': "löschen",
    'Add New': "Neues Konto hinzufügen",
    'MessageBox.delete.bank': "Sind Sie sicher, dass Sie dieses Auszahlungskonto löschen möchten?",
    // 登录
    'Login': "Einloggen",
    'Sign Up': "registrieren",
    'Normal Login': "Normale Anmeldung",
    'Username / Email / Phone Number': "Benutzername/E-Mail",
    'Enter Phone Number': "Bitte geben Sie die Mobiltelefonnummer ein",
    'Enter Email': "Bitte geben Sie Ihre E-Mail-Adresse ein",
    'Enter SMS Code': "Bitte geben Sie den SMS-Bestätigungscode ein",
    'Enter Password': "Bitte geben Sie das Passwort ein",
    "enter_login_password_for_verification": "Bitte geben Sie Ihr Anmeldepasswort zur Verifizierung ein",
    'Forgot Password': "vergessen Sie das Passwort",
    'Third-party Login': "Anmeldung für Dritte",
    'Please complete the form': "Bitte füllen Sie das Formular aus",
    'WeChat': "WeChat",
    'Weibo': "Weibo",
    'QQ': "QQ",
    'phone login': "Mobile Anmeldung",
    'Login Expired': "Die Anmeldung ist abgelaufen",
    'Please enter your phone number first': "Bitte geben Sie zuerst Ihre Handynummer ein",
    'Please enter your username/email/phone number': "Bitte geben Sie Benutzernamen/E-Mail ein",
    'Please enter your password': "Bitte geben Sie das Passwort ein",
    'Password must be at least 6 characters': "Das Passwort muss mindestens 6 Zeichen lang sein",
    'Please enter an 11-digit phone number': "Bitte geben Sie Ihre 11-stellige Mobiltelefonnummer ein",
    'Please wait for the file to finish loading': "Bitte warten Sie, bis die Datei geladen ist",
    'send': "schicken",
    'signUpTips': "Ihre persönlichen Daten werden verwendet, um Ihr Erlebnis auf der Website zu verbessern, den Zugriff auf Ihr Konto zu verwalten und für andere in unserer Datenschutzrichtlinie beschriebene Zwecke.",

    // 注册
    'Sign Up': "registrieren",
    'Referrer': "Empfehlungsgeber",
    'Invitation code': "Einladungscode",
    'Invite friends': "Freunde einladen",
    'Username': "Benutzername",
    'Full Name': "richtiger Name",
    'Set Password': "Passwort festlegen",
    'Confirm Password': "Passwort bestätigen",
    'Phone Number': "Telefonnummer",
    'Email': "E-Mail",
    'Username: 3-25 chars, letters & numbers': "Benutzername: 3-25 Zeichen, Buchstaben und Zahlen",
    '6-20 digits/letters/symbols': "6–20 Ziffern/Buchstaben/Symbole",
    'By clicking sign up, you agree to': "Indem Sie auf „Registrieren“ klicken, stimmen Sie zu",
    'User Agreement': "Benutzervereinbarung",
    'Please check the user agreement': "Bitte überprüfen Sie die Nutzungsvereinbarung",
    'Please enter a username with 3-25 characters': "Bitte geben Sie einen Benutzernamen mit 3-25 Zeichen ein",
    'Enter SMS Verification Code': "Bitte geben Sie den SMS-Bestätigungscode ein",
    'Please enter your phone number': "Bitte geben Sie Ihre Handynummer ein",
    'Please enter the verification code': "Bitte geben Sie den Bestätigungscode ein",
    'Please enter a 6-digit verification code': "Bitte geben Sie den 6-stelligen Bestätigungscode ein",
    'Please enter a password with 6-20 characters': "Bitte geben Sie ein 6-20 Zeichen langes Passwort ein",
    'Please enter the confirm password': "Bitte geben Sie das Bestätigungspasswort ein",
    'The confirm password does not match the entered password': "Das Bestätigungspasswort stimmt nicht mit dem eingegebenen Passwort überein",

    // 密码恢复
    'Password Recovery': "Passwortwiederherstellung",
    'Forgot Password': "vergessen Sie das Passwort",
    'Forget.email.tips': "Wenn Ihrem Konto noch keine E-Mail-Nummer zugeordnet ist, wenden Sie sich bitte an den Plattformadministrator, um Ihr Passwort wiederherzustellen.",

    // 通知
    'Notification Message': "Benachrichtigungsnachricht",
    'Direct Message': "private Nachricht",
    'System Message': "Systemmeldungen",
    'Leave a Message': "Nachricht",

    // 配送地址
    'Delivery Address': "Lieferadresse",
    'The store is no longer valid, please edit the delivery address again': "Dieser Shop ist nicht mehr gültig. Bitte bearbeiten Sie die Lieferadresse erneut",
    'Default address': "Standardadresse",
    'Add address': "Adresse hinzufügen",
    'Edit address': "Adresse bearbeiten",
    'MessageBox.delete.address': "Sind Sie sicher, dass Sie diese Adresse löschen möchten?",
    'name': "Name",
    'phone': "Telefonnummer",
    'district': "Bezirk",
    'address': "Adresse",
    'default address': "Standardadresse",
    'save and use': "Speichern und verwenden",
    'save': "speichern",
    'Please select a region': "Bitte wählen Sie eine Region aus",
    'Please fill in the recipient name': "Bitte geben Sie den Namen des Empfängers ein",
    'Name must be 2-15 characters': "Der Name muss 2–15 Zeichen lang sein",
    'Please fill in the mobile phone number': "Bitte geben Sie die Mobiltelefonnummer ein",
    'Please select your location': "Bitte wählen Sie Ihren Standort aus",
    'Please fill in the detailed address': "Bitte geben Sie die detaillierte Adresse ein",

    // 浏览历史
    'Browsing History': "Durchsuchen Sie den Verlauf",
    'Clear browsing history': "Browserverlauf löschen",

    // 推广会员
    'Promotion member': "Mitglieder fördern",
    "“PromotionPoster”": "Werbeplakat",
    "MemberName": "Mitgliedsname",
    "MyAssets": "mein Vermögen",
    "DistributedAmount": "Ausschüttungsbetrag",
    "NumberOfDistributedProducts": "Produktmenge zuordnen",
    "DistributedProductAmount": "Ausschüttungsbetrag",
    "MyTeam": "mein Team",
    "LevelOneMembers": "erstklassiges Mitglied",
    "LevelTwoMembers": "Mitglied der zweiten Ebene",
    "PromotionPoster": "Werbeplakat",
    "PromotionMembers": "Mitglieder fördern",
    "PromotionPerformance": "Werbeleistung",
    "ViewPromotionLink": "Klicken Sie hier, um den Aktionslink anzuzeigen",
    "PromoteViaWeChatQRCode": "Bewerben Sie über den WeChat-QR-Code",
    "Copy": "Kopie",
    "BrowserNotSupportedCopyManually": "Ihr Browser unterstützt das direkte Kopieren nicht. Bitte kopieren Sie es manuell",
    "GiftCardRecoveryTotal": "Gesamtzahl der recycelten Geschenkkarten",
    "TodaysGiftCardRecoveryCount": "Die heutige Zählung zum Recycling von Geschenkkarten",
    "RegistrationDate": "Anmeldedatum",
    "LastLogin": "letzte Anmeldung",
    "Promotion Commission": "Werbeprovision",

    // userinfo 个人信息
    "Personal Info": "persönliche Informationen",
    "Nickname": "Spitzname",
    "Birthdate": "Geburtsdatum",
    "Save": "speichern",
    "CropImage": "Bild zuschneiden",
    "UseImage": "Verwenden Sie Bilder",

    // goodsDetail 商品详情
    "Off": "Rabatt",
    "Sold": "verkauft",
    "Product": "Produkt",
    "Comment": "Kommentar",
    "Details": "Einzelheiten",
    "ReportViolation": "Bericht",
    "Cart": "Warenkorb",
    "ChatMessages": "Chat-Nachrichten",
    "MyShop": "mein Laden",
    "MerchantLogin": "Händler-Login",
    "Share": "Aktie",
    "ShareTo": "Teilen mit",
    "WeChat": "WeChat",
    "Copy": "Kopie",
    "Poster": "Poster",
    "BrowserNotSupportedCopyManually": "Ihr Browser unterstützt das direkte Kopieren nicht. Bitte kopieren Sie es manuell",
    "Follow": "konzentrieren Sie sich auf",
    "Unfollow": "Nicht mehr folgen",
    "PleaseSelectQuantityAndCategory": "Bitte wählen Sie Menge und Kategorie aus.",
    "SelectedWithQuantity1": "Ausgewählte {Spezifikation}, Menge {Nummer}.",
    "SelectedQuantity1": "Ausgewählte Menge {Nummer}.",
    "SelectedWithQuantity2": "Ausgewählte {Spezifikation}, Menge {Nummer}.",
    "Add to cart": "in den Warenkorb legen",
    "Buy now": "Kaufe es jetzt",
    "Stock": "auf Lager",
    "Pieces": "Stücke",
    "Quantity": "Menge",
    "All": "alle",
    "Good": "Gute Bewertungen",
    "Medium": "Neutrale Bewertung",
    "Bad": "Schlechte Bewertung",
    // 评论
    "Product review": "Produktbewertungen",
    "anonymous": "anonym",
    "noReviewInfo": "Keine Kommentarinformationen angegeben",
    "Shop Owners Response": "Der Ladenbesitzer antwortet",
    "This product has no current reviews": "Für dieses Produkt liegen derzeit keine Bewertungen vor",
    "Product details": "Produktdetails",
    "shop": "Geschäft",
    "customerService": "Warenkorb",
    "shoppingCart": "in den Warenkorb legen",
    "addToCart": "Kaufe es jetzt",
    "buyNow": "Das ausgewählte Produkt ist derzeit leider nicht vorrätig!",
    "outOfStock": "Das ausgewählte Produkt ist leider nicht mehr verfügbar!",
    "notAvailable": "Shop-Bestellnachrichten",
    "Store order message": "Bestellung bestätigen",
    "Confirm the order": "Produktmenge",
    "productAmount": "Rabatt",
    "discount": "Fracht",
    "shippingFee": "Zwischensumme speichern",
    "subtotal": "Bestellung absenden",
    "Submit an order": "Rückerstattung hinzufügen",
    // 退货
    "refundAdd": "zurückkehren",
    "back": "Rückerstattungsanweisungen:",
    "refundDescription": "Rückerstattungsgutschein",
    "proofOfRefund": "verwenden",
    "use": "Kundendienst",
}
export default German
